import { Burger } from '../core'

export default {
  burger: undefined,

  init() {
    /* Burger */
    let obj = this
    // obj.burger = new Burger('.header_menu-toggle', {
    //   onToggle: function() {
    //     var scrollTop = ($('html').scrollTop()) ? $('html').scrollTop() : $('body').scrollTop(); // Works for Chrome, Firefox, IE...
    //     if (scrollTop != 0) {
    //       obj.top = scrollTop
    //     }
    //     $('body').css('--top',-scrollTop + 'px');
    //     if (obj.burger.isExpanded) {
    //       $('body').addClass('--menu-open --no-scroll')
    //     } else {
    //       $('body').removeClass('--menu-open --no-scroll')
    //     }
    //     window.scrollTo({ top: obj.top});
    //   },
    // })

    let window_top = 0;

    $('.header__menu-toggle').click(function() {
      var scrollTop = ($('html').scrollTop()) ? $('html').scrollTop() : $('body').scrollTop(); // Works for Chrome, Firefox, IE...
      if (scrollTop != 0) {
        window_top = scrollTop
      }
      $('body').css('--top',-scrollTop + 'px');
      if (!$('body').hasClass('--menu-open')) {
        $('body').addClass('--menu-open --no-scroll')
      } else {
        $('body').removeClass('--menu-open --no-scroll')
      }
      window.scrollTo({ top: window_top});
    })



    /* Submenu parent */
    $('header .navigation .main-menu > li.main-menu__item--parent').each(function() {
      $(this).SubMenuParent({
        mobile: false,
      });
    })

    $(window).click(function() {
      if ($('body').hasClass('--menu-open')) {
        $('body').removeClass('--menu-open --no-scroll')
        $('.header__search').removeClass('--search-open')
        $('.header__burger').attr('aria-expanded', 'false');
        window.scrollTo({ top: window_top});
        $('main .page-section').first().click();
      }
    });

    $('.header__menu-toggle, .navigation__wrapper, .header__burger, .header__search, .header__search-btn').click(function(event){
      event.stopPropagation();
    });

    /* Calculate header height */
    $(window).on('resize load orientationchange', header)
    header()

    // /* Language display */
    // $.mlmi.mobile.add(function() {
    //   $('.wpml-ls-native[lang="en"]').text('Switch to english')
    //   $('.wpml-ls-native[lang="fr"]').text('Passer en français')
    // }, function() {
    //   $('.wpml-ls-native[lang="en"]').text('EN')
    //   $('.wpml-ls-native[lang="fr"]').text('FR')
    // })
  }
}
